(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredcf9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredcf9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d8HMG", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $990dfc566758140d$export$6503ec6e8aabbaf; }, function (v) { return $990dfc566758140d$export$6503ec6e8aabbaf = v; });
var $990dfc566758140d$export$6503ec6e8aabbaf;
var $990dfc566758140d$export$f7ad0328861e2f03;
"use strict";
var $990dfc566758140d$var$mapping = new Map();
function $990dfc566758140d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$990dfc566758140d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $990dfc566758140d$var$resolve(id) {
    var resolved = $990dfc566758140d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$990dfc566758140d$export$6503ec6e8aabbaf = $990dfc566758140d$var$register;
$990dfc566758140d$export$f7ad0328861e2f03 = $990dfc566758140d$var$resolve;

});

parcelRegister("3VV9c", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2dd306457558c0ef$export$bdfd709ae4826697; }, function (v) { return $2dd306457558c0ef$export$bdfd709ae4826697 = v; });
var $2dd306457558c0ef$export$bdfd709ae4826697;
var $2dd306457558c0ef$export$c9e73fbda7da57b6;
var $2dd306457558c0ef$export$5a759dc7a1cfb72a;
"use strict";
var $2dd306457558c0ef$var$bundleURL = {};
function $2dd306457558c0ef$var$getBundleURLCached(id) {
    var value = $2dd306457558c0ef$var$bundleURL[id];
    if (!value) {
        value = $2dd306457558c0ef$var$getBundleURL();
        $2dd306457558c0ef$var$bundleURL[id] = value;
    }
    return value;
}
function $2dd306457558c0ef$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2dd306457558c0ef$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2dd306457558c0ef$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2dd306457558c0ef$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2dd306457558c0ef$export$bdfd709ae4826697 = $2dd306457558c0ef$var$getBundleURLCached;
$2dd306457558c0ef$export$c9e73fbda7da57b6 = $2dd306457558c0ef$var$getBaseURL;
$2dd306457558c0ef$export$5a759dc7a1cfb72a = $2dd306457558c0ef$var$getOrigin;

});

var $867413a594bb04f6$exports = {};


(parcelRequire("d8HMG")).register((parcelRequire("3VV9c")).getBundleURL("dswdd"), JSON.parse('["dswdd","theme.js","jM6TR","resources/favicons/favicon.png","3EFNZ","resources/favicons/apple-touch-icon.png","kCxff","resources/favicons/favicon-32x32.png","5tyBu","resources/favicons/favicon-16x16.png","bVM57","resources/favicons/safari-pinned-tab.svg","eDMju","theme.css"]'));

// Stylesheets

var $7b051baa7fa30ab0$exports = {};

$7b051baa7fa30ab0$exports = (parcelRequire("3VV9c")).getBundleURL("dswdd") + "resources/favicons/favicon.png";


const $8d7a60d7c8b8bc0f$var$loadHeader = ()=>{
    const header = document.querySelector(".header");
    const container = header.querySelector(".cmp-container");
    let mobileVisible = false;
    // Creates the hamburger menu
    const hamburgerButton = document.createElement("button");
    hamburgerButton.className = "header__hamburger-button";
    hamburgerButton.innerHTML = `
      <div class="header__hamburger-bar"></div>
      <div class="header__hamburger-bar"></div>
      <div class="header__hamburger-bar"></div>
    `;
    header.querySelector("ul").id = "hamburger-menu";
    container.insertBefore(hamburgerButton, container.firstChild);
    const toggleMenu = ()=>{
        const headerNavigation = document.querySelector(".header__navigation");
        if (mobileVisible) {
            hamburgerButton.setAttribute("aria-expanded", "false");
            headerNavigation.classList.remove("header__navigation-visible");
        } else {
            hamburgerButton.setAttribute("aria-expanded", "true");
            headerNavigation.classList.add("header__navigation-visible");
        }
        mobileVisible = !mobileVisible;
    };
    hamburgerButton.addEventListener("click", toggleMenu);
    const navigation = document.querySelector(".header__navigation");
    const liElementsWithUl = [
        ...navigation.querySelectorAll("li > ul")
    ].map((e)=>e.parentNode);
    const resetMenu = ()=>{
        const headerNavigation = document.querySelector(".header__navigation");
        headerNavigation.classList.remove("header__navigation-visible");
        if (window.innerWidth < 768) {
            hamburgerButton.setAttribute("aria-controls", `hamburger-menu`);
            hamburgerButton.setAttribute("aria-expanded", "false");
        } else {
            hamburgerButton.removeAttribute("aria-expanded");
            hamburgerButton.removeAttribute("aria-controls");
        }
    };
    const toggle = (li)=>{
        li.classList.toggle("opened");
        if (li.classList.contains("opened")) {
            li.setAttribute("aria-expanded", "true");
            closeMenus(li);
        } else li.setAttribute("aria-expanded", "false");
    };
    const closeMenus = (li = null)=>{
        liElementsWithUl.forEach((element)=>{
            if (element !== li) {
                element.classList.remove("opened");
                element.setAttribute("aria-expanded", "false");
            }
        });
    };
    const handleResize = ()=>{
        if (mobileVisible) {
            toggleMenu();
            closeMenus();
        }
        resetMenu();
    };
    resetMenu();
    if (navigation) {
        liElementsWithUl.forEach((li, index)=>{
            li.setAttribute("aria-expanded", "false");
            li.setAttribute("tabindex", "0");
            li.querySelector("ul").id = `header-links-${index}`;
            li.setAttribute("aria-controls", `header-links-${index}`);
            li.addEventListener("mouseenter", (event)=>{
                if (window.innerWidth > 768) {
                    li.setAttribute("aria-expanded", "true");
                    closeMenus(li);
                }
            });
            li.addEventListener("mouseleave", (event)=>{
                if (window.innerWidth > 768) li.setAttribute("aria-expanded", "false");
            });
            li.addEventListener("click", (event)=>{
                if (window.innerWidth <= 768) toggle(li);
            });
            li.addEventListener("keyup", (event)=>{
                if (event.key === "Enter") toggle(li);
            });
            li.addEventListener("blur", (event)=>{
                if (window.innerWidth <= 768) {
                    if (!liElement.contains(event.relatedTarget)) {
                        liElement.classList.remove("opened");
                        liElement.setAttribute("aria-expanded", "false");
                    }
                }
            });
        });
        // Adds 'has-ul' class to elements. Temp fix until 'has' selector is universally available in all browsers
        var liAndUlElements = document.querySelectorAll(".header__navigation li, .header__navigation ul");
        liAndUlElements.forEach((element)=>{
            if (element.querySelector("ul")) element.classList.add("has-ul");
        });
    }
    window.addEventListener("resize", handleResize);
};
if (document.readyState !== "loading") $8d7a60d7c8b8bc0f$var$loadHeader();
else document.addEventListener("DOMContentLoaded", $8d7a60d7c8b8bc0f$var$loadHeader);


const $dfc644fdaf79a9b5$var$loadFooter = ()=>{
    // This handles functionality related to tabbing for accessibility
    const footerLinks = document.querySelector(".footer .footer__links");
    const firstCmpText = footerLinks.querySelector(".cmp-text ul");
    $dfc644fdaf79a9b5$var$findSections();
    window.onresize = ()=>{
        $dfc644fdaf79a9b5$var$resetTabs(firstCmpText);
        $dfc644fdaf79a9b5$var$closeMenus();
    };
    $dfc644fdaf79a9b5$var$resetTabs(firstCmpText);
    // Add tabbing to mobile and implements mobile clicking on sections
    $dfc644fdaf79a9b5$var$liItems().forEach((li)=>{
        if (li.parentNode === firstCmpText && li.querySelector("ul")) {
            li.addEventListener("click", ()=>{
                if (window.innerWidth <= 768) {
                    $dfc644fdaf79a9b5$var$toggle(li);
                    $dfc644fdaf79a9b5$var$closeMenus(li);
                }
                $dfc644fdaf79a9b5$var$liItems().forEach((element)=>{
                    if (element !== li && element.classList.contains("opened")) {
                        element.setAttribute("aria-expanded", "false");
                        element.classList.remove("opened");
                    }
                });
            });
            li.addEventListener("keyup", (event)=>{
                if (event.key === "Enter") {
                    $dfc644fdaf79a9b5$var$toggle(li);
                    $dfc644fdaf79a9b5$var$closeMenus(li);
                }
            });
        }
    });
};
const $dfc644fdaf79a9b5$var$liItems = ()=>{
    return document.querySelector(".footer .footer__links").querySelector(".cmp-text ul").querySelectorAll("li");
};
const $dfc644fdaf79a9b5$var$closeMenus = (li = null)=>{
    $dfc644fdaf79a9b5$var$liItems().forEach((element)=>{
        if ((!li || element !== li) && element.querySelector("ul")) {
            element.classList.remove("opened");
            element.setAttribute("aria-expanded", "false");
        }
    });
};
// Resets if the screen size changes
const $dfc644fdaf79a9b5$var$resetTabs = (firstCmpText)=>{
    $dfc644fdaf79a9b5$var$liItems().forEach((li, index)=>{
        if (li.parentNode === firstCmpText && li.querySelector("ul")) {
            li.querySelector("ul").id = `footer-links-${index}`;
            if (window.innerWidth <= 768) {
                li.setAttribute("tabindex", "0");
                li.setAttribute("aria-expanded", "false");
                li.setAttribute("aria-controls", `footer-links-${index}`);
            } else {
                li.setAttribute("tabindex", "-1");
                li.removeAttribute("aria-expanded");
                li.removeAttribute("aria-controls");
            }
        }
    });
};
const $dfc644fdaf79a9b5$var$toggle = (li)=>{
    li.classList.toggle("opened");
    if (li.classList.contains("opened")) {
        li.setAttribute("aria-expanded", "true");
        $dfc644fdaf79a9b5$var$closeMenus(li);
    } else li.setAttribute("aria-expanded", "false");
};
const $dfc644fdaf79a9b5$var$findSections = ()=>{
    const targetElements = document.querySelectorAll(".footer__links > .cmp-text > ul > li");
    const elementsWithLiChild = Array.from(targetElements).filter((element)=>element.querySelector("li"));
    elementsWithLiChild.forEach((element)=>{
        element.classList.add("has-li");
    });
};
if (document.readyState !== "loading") $dfc644fdaf79a9b5$var$loadFooter();
else document.addEventListener("DOMContentLoaded", $dfc644fdaf79a9b5$var$loadFooter);


document.addEventListener("DOMContentLoaded", function(event) {
    var x, i, j, l, ll, selElmnt, a, b, c;
    x = document.getElementsByClassName("cmp-form-options--drop-down");
    l = x.length;
    for(i = 0; i < l; i++){
        selElmnt = x[i].getElementsByTagName("select")[0];
        if (typeof selElmnt === "undefined") return;
        ll = selElmnt.length;
        /* For each element, create a new DIV that will act as the selected item: */ a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /* For each element, create a new DIV that will contain the option list: */ b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for(j = 1; j < ll; j++){
            /* For each option in the original select element,
            create a new DIV that will act as an option item: */ c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener("click", function(e) {
                /* When an item is clicked, update the original select box,
                and the selected item: */ var y, i, k, s, h, sl, yl;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                sl = s.length;
                h = this.parentNode.previousSibling;
                for(i = 0; i < sl; i++)if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    yl = y.length;
                    for(k = 0; k < yl; k++)y[k].removeAttribute("class");
                    this.setAttribute("class", "same-as-selected");
                    break;
                }
                h.click();
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function(e) {
            /* When the select box is clicked, close any other select boxes,
            and open/close the current select box: */ e.stopPropagation();
            $0912e84f77a6e2bc$var$closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
        });
    }
});
function $0912e84f77a6e2bc$var$closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document,
    except the current select box: */ var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for(i = 0; i < yl; i++)if (elmnt == y[i]) arrNo.push(i);
    else y[i].classList.remove("select-arrow-active");
    for(i = 0; i < xl; i++)if (arrNo.indexOf(i)) x[i].classList.add("select-hide");
}
/* If the user clicks anywhere outside the select box,
then close all select boxes: */ document.addEventListener("click", $0912e84f77a6e2bc$var$closeAllSelect);


document.addEventListener("DOMContentLoaded", function(event) {
    var x = document.getElementsByClassName("cmp-progressbar");
    var targetElements = document.getElementsByClassName("progressbar");
    var l = x.length;
    for(var i = 0; i < l; i++){
        var percentage = x[i].firstElementChild.textContent;
        var element = document.createElement("div");
        element.setAttribute("class", "cmp-progressbar-completedPercentage");
        var text = document.createTextNode(percentage + "%");
        element.appendChild(text);
        if (typeof targetElements[i] !== "undefined") targetElements[i].insertBefore(element, targetElements[i].firstChild);
    }
});


const $7ad3068d6db6eaed$var$openAccordion = (btn, tabList)=>{
    btn.setAttribute("aria-expanded", true);
    btn.classList.add("expanded");
    tabList.classList.add("expanded");
};
const $7ad3068d6db6eaed$var$closeAccordion = (btn, tabList)=>{
    btn.setAttribute("aria-expanded", false);
    btn.classList.remove("expanded");
    tabList.classList.remove("expanded");
};
const $7ad3068d6db6eaed$var$setUpFAQTabStyle = (component, index)=>{
    const tabContainer = component.querySelector(".cmp-tabs");
    const tabList = tabContainer?.querySelector(".cmp-tabs__tablist");
    const tabListId = `cmp-tab-list-${index}`;
    tabList.setAttribute("id", tabListId);
    // State variables
    let isOpen = false;
    // Render dropdown
    const accordionBtn = document.createElement("button");
    accordionBtn.classList.add("cmp-tabs__dropdown-selector");
    accordionBtn.setAttribute("aria-expanded", isOpen);
    accordionBtn.setAttribute("aria-controls", tabListId);
    accordionBtn.textContent = "Sort By";
    tabContainer.prepend(accordionBtn);
    // Open/Close accordion on accordionBtn click
    accordionBtn.addEventListener("click", ()=>{
        isOpen = !isOpen;
        if (isOpen) $7ad3068d6db6eaed$var$openAccordion(accordionBtn, tabList);
        else $7ad3068d6db6eaed$var$closeAccordion(accordionBtn, tabList);
    });
};
const $7ad3068d6db6eaed$var$loadTabStyles = ()=>{
    const tabComponent = document.querySelectorAll(".tabs.faq");
    tabComponent?.forEach((component, i)=>{
        if (component.classList.contains("faq")) $7ad3068d6db6eaed$var$setUpFAQTabStyle(component, i);
    });
};
if (document.readyState !== "loading") $7ad3068d6db6eaed$var$loadTabStyles();
else document.addEventListener("DOMContentLoaded", $7ad3068d6db6eaed$var$loadTabStyles);


const $ebdc309aa8a68229$var$CLASSES = {
    container: "cmp-embed__pricespider",
    button: "cmp-button"
};
const $ebdc309aa8a68229$var$checkAndRebind = ()=>{
    if (window.PriceSpider?.WidgetBinder?.findUnboundWidgets().length > 0) window.PriceSpider.rebind();
};
const $ebdc309aa8a68229$var$initPriceSpiderComponent = ()=>{
    const scriptUrl = document.querySelector(`.${$ebdc309aa8a68229$var$CLASSES.container} script`)?.getAttribute("data-src");
    if (scriptUrl) {
        const script = document.createElement("script");
        script.setAttribute("src", encodeURI(scriptUrl));
        document.head.appendChild(script);
        window.addEventListener("scroll", $ebdc309aa8a68229$var$checkAndRebind);
        window.addEventListener("resize", $ebdc309aa8a68229$var$checkAndRebind());
    }
};
if (document.readyState !== "loading") $ebdc309aa8a68229$var$initPriceSpiderComponent();
else document.addEventListener("DOMContentLoaded", $ebdc309aa8a68229$var$initPriceSpiderComponent);


const $f52f34e418758f66$var$EventType = {
    firebaseEvent: "firebaseEventSent",
    resizeWindow: "resizeWindowResponse"
};
const $f52f34e418758f66$var$lazyLoadIframes = ()=>{
    console.log("loading iframe");
    const iframes = document.querySelectorAll("iframe[data-src]");
    iframes.forEach((iframe)=>{
        iframe.src = iframe.dataset.src;
    });
};
const $f52f34e418758f66$var$CLASSES = {
    thirdPartyExperienceComponent: "cmp-embed__third-party-experience"
};
const $f52f34e418758f66$var$events = {
    sendFirebaseEvent: function(payload) {
        var name = payload.name;
        var params = payload.params;
        var events = {
            data: params
        };
        // sendAnalyticsEvent(payload, name, events);
        var firebaseResponse = {
            original_event_name: name,
            message: "Firebase event successfully sent"
        };
        postMessage(payload, {
            event: $f52f34e418758f66$var$EventType.firebaseEvent,
            data: firebaseResponse
        });
    },
    resizeWindow: async function(payload) {
        const { height: height } = JSON.parse(payload.param);
        let response;
        if (!Number.isInteger(height) || !(height > 0)) response = {
            error: "bad_input",
            message: "height must be an integer and greater than zero"
        };
        else {
            const iframes = document.querySelectorAll(`.${$f52f34e418758f66$var$CLASSES.thirdPartyExperienceComponent}`);
            if (iframes) {
                iframes.forEach((_iframe)=>{
                    _iframe.style.height = `${height}px`;
                    _iframe.style.aspectRatio = "unset";
                });
                response = {
                    message: `height set to ${height}px`
                };
            }
        }
        const responseMessage = {
            event: $f52f34e418758f66$var$EventType.resizeWindow,
            payload: response
        };
        postMessage(payload, responseMessage);
    }
};
const $f52f34e418758f66$var$isJSON = (message)=>{
    try {
        return !!JSON.parse(message);
    } catch (error) {
        return false;
    }
};
const $f52f34e418758f66$var$processMessage = function(payload) {
    if ($f52f34e418758f66$var$isJSON(payload)) {
        var data = JSON.parse(payload);
        if (data.event in $f52f34e418758f66$var$events && typeof $f52f34e418758f66$var$events[data.event] === "function") $f52f34e418758f66$var$events[data.event](data);
    }
};
const $f52f34e418758f66$var$setupIframeCommunication = async function() {
    window.addEventListener("message", function(event) {
        $f52f34e418758f66$var$processMessage(event.data);
    });
};
function $f52f34e418758f66$var$init() {
    $f52f34e418758f66$var$lazyLoadIframes();
    $f52f34e418758f66$var$setupIframeCommunication();
}
if (document.readyState !== "loading") $f52f34e418758f66$var$init();
else document.addEventListener("DOMContentLoaded", $f52f34e418758f66$var$init);


const $a2d7bdf4faa34866$export$b2c178050f0c51a2 = (element, threshold = 0)=>{
    const { top: top, bottom: bottom } = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const elementTopVisible = top < windowHeight + threshold && top > 0;
    const elementBottomVisible = bottom > 0 - threshold && bottom < windowHeight;
    return elementTopVisible || elementBottomVisible;
};
const $a2d7bdf4faa34866$export$795910f5f15a9633 = (element)=>Boolean(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
class $a2d7bdf4faa34866$export$1caf10789e8ce094 {
    constructor(element, options = {
        threshold: 0
    }){
        this.element = element;
        this.threshold = options.threshold;
        this.controller = new AbortController();
    }
    observe(callbackFn, occurrence = "constant") {
        const tryInvokeCallback = ()=>{
            if ($a2d7bdf4faa34866$export$b2c178050f0c51a2(this.element, this.threshold)) {
                callbackFn();
                if (occurrence === "single") this.controller.abort();
            }
        };
        tryInvokeCallback();
        window.addEventListener("scroll", tryInvokeCallback, {
            signal: this.controller.signal
        });
        window.addEventListener("resize", tryInvokeCallback, {
            signal: this.controller.signal
        });
    }
    stopObserve() {
        this.controller.abort();
    }
}


const $6e22cf78972bdbc0$var$CLASSES = {
    spotifyPlaceholder: "spotify-placeholder",
    spotifyComponent: "cmp-embed__spotify"
};
const $6e22cf78972bdbc0$var$SPOTIFY_IFRAME_API_URL = "https://open.spotify.com/embed-podcast/iframe-api/v1";
const $6e22cf78972bdbc0$var$loadSpotify = ()=>{
    let initialised = false;
    let initQueue = [];
    let IFrameAPI;
    const initPlayer = (player)=>{
        if (initialised) loadPlayer(player);
        else {
            initSpotifyApi();
            initQueue.push(player);
            tryRunLoadQueue();
        }
    };
    const setScriptLoaded = (script)=>{
        window.Spotify.loaded = "initialised";
        IFrameAPI = script;
        initialised = true;
        tryRunLoadQueue();
    };
    const initSpotifyApi = ()=>{
        if (window.Spotify.loaded !== "not_started") return;
        window.Spotify.loaded = "pending";
        const scriptElement = document.createElement("script");
        scriptElement.src = $6e22cf78972bdbc0$var$SPOTIFY_IFRAME_API_URL;
        const bodyElement = document.getElementsByTagName("body")[0];
        bodyElement.appendChild(scriptElement);
    };
    const tryRunLoadQueue = ()=>{
        if (!initialised) return;
        initQueue.forEach((player, index)=>{
            if (!player) return;
            loadPlayer(player);
            initQueue[index] = undefined;
        });
    };
    const getSpotifyTitle = async (spotifyUrl)=>{
        const apiUrl = new URL("https://open.spotify.com/oembed");
        apiUrl.searchParams.set("url", encodeURI(spotifyUrl));
        try {
            const response = await fetch(apiUrl, {
                method: "GET",
                mode: "cors"
            });
            const data = await response.json();
            return data.title;
        } catch  {
            return "";
        }
    };
    const emitSpotifyEvent = async (url)=>{
        const event = {
            event: "play_spotify",
            embed_title: await getSpotifyTitle(url),
            embed_url: url
        };
        CepDataLayer.push(event);
    };
    const loadPlayer = (player)=>{
        const { type: type, uri: uri, src: src } = JSON.parse(player.dataset.iframe);
        let eventEmitted = false;
        const options = {
            height: type === "track" ? 105 : 398,
            uri: uri
        };
        const callback = (EmbedController)=>{
            EmbedController.addListener("playback_update", (e)=>{
                if (!e.data.isPaused && !eventEmitted) {
                    emitSpotifyEvent(src);
                    eventEmitted = true;
                } else if (e.data.isPaused) eventEmitted = false;
            });
        };
        IFrameAPI.createController(player, options, callback);
    };
    const initialize = ()=>{
        if (typeof window !== "undefined") {
            window.onSpotifyIframeApiReady = window.onSpotifyIframeApiReady || function(IFrameAPI) {
                console.log("Spotify IFrame API is ready", IFrameAPI);
            };
            window.Spotify = window.Spotify || {
                loaded: "not_started"
            };
        }
        const spotifyEmbed = document.querySelector(`.${$6e22cf78972bdbc0$var$CLASSES.spotifyComponent}`);
        if (!Boolean(spotifyEmbed)) return;
        window.onSpotifyIframeApiReady = (IFrameAPI)=>{
            console.log("callback");
            setScriptLoaded(IFrameAPI);
        };
        if (!window.Spotify) window["Spotify"] = {
            loaded: "not_started"
        };
        const spotifyPlayers = document.querySelectorAll(`.${$6e22cf78972bdbc0$var$CLASSES.spotifyPlaceholder}`);
        spotifyPlayers.forEach((player)=>{
            const observer = new (0, $a2d7bdf4faa34866$export$1caf10789e8ce094)(player, {
                threshold: 200
            });
            observer.observe(()=>{
                initPlayer(player);
            }, "single");
        });
    };
    initialize();
};
if (document.readyState !== "loading") $6e22cf78972bdbc0$var$loadSpotify();
else document.addEventListener("DOMContentLoaded", $6e22cf78972bdbc0$var$loadSpotify);


function $41402906e2bc27e9$var$initSweepsIframe() {
    var iframe = document.getElementById("sweepsiframe");
    if (iframe) {
        iframe.setAttribute("scrolling", "no");
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://cdn.dja.com/js/iframe.js";
        iframe.insertAdjacentElement("afterend", script);
    }
}
if (document.readyState !== "loading") $41402906e2bc27e9$var$initSweepsIframe();
else document.addEventListener("DOMContentLoaded", $41402906e2bc27e9$var$initSweepsIframe);


var $61923e5946ddfc14$exports = {};

$61923e5946ddfc14$exports = (parcelRequire("3VV9c")).getBundleURL("dswdd") + "resources/favicons/apple-touch-icon.png";


var $3e65469147cf9be1$exports = {};

$3e65469147cf9be1$exports = (parcelRequire("3VV9c")).getBundleURL("dswdd") + "resources/favicons/favicon-32x32.png";


var $9736dad6c3cbef04$exports = {};

$9736dad6c3cbef04$exports = (parcelRequire("3VV9c")).getBundleURL("dswdd") + "resources/favicons/favicon-16x16.png";


var $6c3bde9c5043bfbf$exports = {};

$6c3bde9c5043bfbf$exports = (parcelRequire("3VV9c")).getBundleURL("dswdd") + "resources/favicons/safari-pinned-tab.svg";



})();
//# sourceMappingURL=theme.js.map
